// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3rKwSXsSbdkqZqDgYhpm2k"};


//////////////////
// WEBPACK FOOTER
// ../components/wrapper/styles.module.css
// module id = 400
// module chunks = 0